// 📄 components/layout/ThemeToggle.tsx
import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext.tsx';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      aria-label="Cambiar tema"
      title={isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
      className="relative flex-shrink-0 flex items-center w-14 h-7 rounded-full bg-white/10 border border-white/10 hover:bg-white/15 transition-colors"
    >
      <span
        className={`absolute top-0.5 w-6 h-6 rounded-full bg-[#fff] shadow-md flex items-center justify-center transition-all duration-200 ${
          isDark ? 'left-7' : 'left-0.5'
        }`}
      >
        {isDark ? (
          <Moon className="w-3.5 h-3.5 text-indigo-600" />
        ) : (
          <Sun className="w-3.5 h-3.5 text-amber-500" />
        )}
      </span>
    </button>
  );
}
